import useAuth from "./useAuth";
import { hasPermission, hasAnyPermission } from "../utils/permissions";

// Lee los permisos del usuario del contexto de auth (JWT decodificado). Sin
// provider o sin sesión devuelve false: nunca lanza.

/** @param {string} key clave canónica, p. ej. "role:read" */
export function usePermission(key) {
  const auth = useAuth();
  return hasPermission(auth?.user, key);
}

/** @param {string[]} keys true si el usuario tiene al menos una */
export function useAnyPermission(keys) {
  const auth = useAuth();
  return hasAnyPermission(auth?.user, keys);
}

export default usePermission;
